<template>
    <div>
        <popup-detail-component :popupKey="popupKey"></popup-detail-component>
    </div>
</template>

<script>
    import PopupDetailComponent from "@/components/popup/PopupDetailComponent";
    export default {
        name: "PopupDetail",
        mixins: [],
        components: {PopupDetailComponent},
        props: {},
        data() {
            return {
                popupKey:''
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.getBoardKey()
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            getBoardKey(){
                this.popupKey = this.$route.params.p_idx
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>